import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { Options, V2AdminCreateBlogPostData } from '@workspace/api-backend'
import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { useAdminCreateBlogPostMutation } from '../../../features/admin/hooks/use-admin-api'
import { BlogForm, type BlogFormData } from '../../../features/blog/components/blog-form'

export const Route = createFileRoute('/admin/blog/new')({
  component: Page,
})

function Page() {
  const navigate = useNavigate()
  const createMutation = useAdminCreateBlogPostMutation()

  const handleSubmit = (data: BlogFormData) => {
    createMutation.mutate(
      {
        body: {
          title: data.title,
          content: data.content,
          excerpt: data.excerpt || undefined,
          metaDescription: data.metaDescription || undefined,
          coverImageUrl: data.coverImageUrl || undefined,
          tags: data.tags,
          targetQueries: data.targetQueries,
          status: data.status,
        },
      } as Options<V2AdminCreateBlogPostData>,
      {
        onSuccess: (response) => {
          if (response.status === 'ok') {
            navigate({ to: '/admin/blog/$id', params: { id: response.data.id } })
          }
        },
      }
    )
  }

  return (
    <div className="mx-auto w-full max-w-4xl space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">New Blog Post</h1>
        <CtaButton size="sm" type="submit" form="blog-new-form" loading={createMutation.isPending}>
          Save
        </CtaButton>
      </div>

      <BlogForm
        formId="blog-new-form"
        onSubmit={handleSubmit}
        isSubmitting={createMutation.isPending}
      />
    </div>
  )
}
